import { Routes } from '@angular/router';
import { Authority } from '@app/shared/utils/enums';
import { SiteIpInfoComponent } from '@app/features/site-ip-info/site-ip-info.component';

export const siteIpInfoRoutes: Routes = [
    {
        path: 'site-ip-info',
        children: [
            {
                path: '',
                component: SiteIpInfoComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE, Authority.INTL]
                }
            }
        ]
    },
    // Old name for this page; keeps existing bookmarks working
    { path: 'lan-dns', redirectTo: 'site-ip-info' }
]